"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
import { LiveTag } from "../ui/LiveTag";
export default function ScoreCard() {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-6 pb-4 border-b border-464646B"> <span className="flex"><LiveTag id="1" /></span><span className="text-D2D2D2 text-14-tamil-400">Upcoming</span><span className="text-D2D2D2 text-14-tamil-400">Recent</span></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="grid grid-cols-1 justify-center lg:items-end items-center  "><span className="text-FFFFFF text-14-tamil-600 flex">வ. கோஹ்லி : 57 (43)</span><span className="text-E8E8E8 text-14-tamil-400 flex">க. பிளெக்ஸ் : 66 (46)</span></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="text-FFFFFF text-18-tamil-700 flex lg:justify-end">INDIA</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col lg:items-end lg:justify-end">{t2}<div className="lg:flex flex-row-reverse items-center gap-2 text-FFDB59 justify-end gap-4"><span className="text-12-tamil-400">(62.4 ov)</span><span className="text-18-tamil-500">220</span></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="lg:grid lg:grid-cols-2 flex flex-col-reverse flex-col gap-5 justify-center lg:items-center">{t1}<div className="lg:grid lg:grid-cols-2 justify-end flex flex-row-reverse gap-4">{t3}<div className="flex justify-start"><Image src="https://media.dinamani.com/dinamani/2026-02-27/ng8cvwuh/IndiaFlag.png" alt="/" width={56} height={56} className="rounded-sm" /></div></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="grid items-center justify-start gap-2 p-5"><div className="px-2 py-1 bg-0ABDF4 text-FFFFFF rounded">VS</div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex items-center gap-5 justify-end"><Image src="https://media.dinamani.com/dinamani/2026-02-27/po3cer3m/AustraliaFlag.png" alt="australia flag" width={56} height={56} className="rounded-sm" /></div>;
    t7 = <span className="text-FFFFFF text-18-tamil-700">AUSTRALIA</span>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="lg:grid lg:grid-cols-2 flex justify-start gap-4">{t6}<div>{t7}<div className="flex items-center gap-2 text-FFDB59"><span className="text-18-tamil-500">168/6</span><span className="text-12-tamil-400">(62.4 ov)</span></div></div></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="w-full bg-[#2a2a2a] text-white p-4 rounded-md lg:flex lg:flex-col gap-5">{t0}<div className="flex  mt-4 grid grid-cols-1 items-center justify-center lg:flex lg:justify-between lg:items-center gap-5">{t4}{t5}<div className="lg:flex grid grid-cols-1 gap-5 lg:justify-center lg:items-center">{t8}<div className="lg:flex lg:flex-col  "><span className="text-FFFFFF text-14-tamil-600 flex">எ. சிங் : 0/26 (3.2)</span><span className="text-D2D2D2 text-12-tamil-400 flex">என். எல்னிஸ் : 0/35 (3.0)</span></div></div></div><div className="flex items-center justify-center text-FFFFFF text-16-tamil-500 mt-4 pt-4 border-t border-464646B">களத்தில்ச் வெற்றிக்கு 52 பந்துகளில் 81 ரன்கள் தேவை</div></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
}